// import React, { useState, useRef, useEffect } from "react";

import NewItemTransform from "../../../../components/@documents/item_transform/ViewItemTransform";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemTransformViewPage() {

    return (
        <NewItemTransform 
            routeType={routeTypes.admin}
        />
    )
}